// Mock data for The Lokal Winery

export const wineTypes = [
  {
    id: 1,
    category: 'Dry Whites',
    varieties: ['Chardonnay', 'Pinot Grigio', 'Sauvignon Blanc']
  },
  {
    id: 2,
    category: 'Off-Dry Whites',
    varieties: ['Riesling', 'Gewürztraminer']
  },
  {
    id: 3,
    category: 'Robust Reds',
    varieties: ['Cabernet Sauvignon', 'Merlot', 'Shiraz', 'Pinot Noir']
  },
  {
    id: 4,
    category: 'Fruit Wines',
    varieties: ['Strawberry', 'Peach', 'Raspberry']
  },
  {
    id: 5,
    category: 'Flavoured Ports',
    varieties: ['Cherry Port', 'Chocolate Port']
  },
  {
    id: 6,
    category: 'Ciders',
    varieties: ['Apple Cider', 'Pear Cider']
  }
];

export const processSteps = [
  {
    id: 1,
    title: 'Select a wine',
    icon: 'https://images.squarespace-cdn.com/content/v1/5be9a984f8370a38e3b406f7/ad3df962-050f-4211-bed8-db4964e536d0/Website+-+Wine+Icon.png',
    description: 'Not sure what kind of wine to make? We can help you pick! Each kit makes 30 - 750 ml bottles of wine.'
  },
  {
    id: 2,
    title: 'Prep wine',
    icon: 'https://images.squarespace-cdn.com/content/v1/5be9a984f8370a38e3b406f7/a4fedaaa-9685-4e8d-99c0-1f7d502123f8/Website+-+Wine+Icon+%282%29.png',
    description: 'Your wine is complemented with unique ingredients that make every kit special. You just need to add the yeast.'
  },
  {
    id: 3,
    title: 'Fermentation',
    icon: 'https://images.squarespace-cdn.com/content/v1/5be9a984f8370a38e3b406f7/1dad404c-80a1-4ac9-9161-db91e4f9e6ae/Website+-+Wine+Icon+%283%29.png',
    description: 'Now that fermentation has started, your wine needs time to age. Your wine will be available in 4-8 weeks.'
  },
  {
    id: 4,
    title: 'Bottle & Enjoy',
    icon: 'https://images.squarespace-cdn.com/content/v1/5be9a984f8370a38e3b406f7/14806cbd-bffe-498b-bac1-7342cb80499a/Website+-+Wine+Icon+%281%29.png',
    description: 'Your invoice will note the earliest your wine will be ready. Give us a call to book your bottling appointment.'
  }
];

export const benefits = [
  {
    id: 1,
    icon: '⏱️',
    text: '30 minutes to bottle your wine'
  },
  {
    id: 2,
    icon: '🍷',
    text: 'Each kit makes 30 750-ml bottles'
  },
  {
    id: 3,
    icon: '📊',
    text: 'Alcohol content ranges from 8-13%'
  }
];

export const testimonials = [
  {
    id: 1,
    name: 'Aaron Turpin',
    rating: 5,
    review: 'But the dry cider was amazing, and the gift shop is worth browsing for sure.',
    date: 'Google Review'
  },
  {
    id: 2,
    name: 'Terry Blackmore',
    rating: 5,
    review: 'The prices are fair and staff incredible.',
    date: 'Google Review'
  },
  {
    id: 3,
    name: 'Dean Bush',
    rating: 5,
    review: 'Very knowledgeable & a great experience from start to finish.',
    date: 'Google Review'
  },
  {
    id: 4,
    name: 'Sarah M.',
    rating: 5,
    review: 'Absolutely love The Lokal! The staff walked us through the entire wine-making process and helped us choose the perfect wine. Can\'t wait to come back for bottling!',
    date: 'Google Review'
  },
  {
    id: 5,
    name: 'Mike P.',
    rating: 5,
    review: 'Best wine-making experience in Kawartha Lakes! The selection is incredible and the prices are unbeatable. Our Cabernet Sauvignon turned out amazing.',
    date: 'Google Review'
  },
  {
    id: 6,
    name: 'Jennifer L.',
    rating: 5,
    review: 'Such a fun and unique experience! Made a fruit wine for summer and everyone at our party loved it. The staff made the whole process so easy.',
    date: 'Google Review'
  },
  {
    id: 7,
    name: 'Robert K.',
    rating: 5,
    review: 'Quality wine at a fraction of the cost! Been making my own wine here for years. The Lokal team is always helpful and the results are consistently excellent.',
    date: 'Google Review'
  },
  {
    id: 8,
    name: 'Lisa W.',
    rating: 5,
    review: 'Fantastic local business! Love supporting The Lokal. The wine kits are top quality and the marketplace has beautiful gifts. Highly recommend!',
    date: 'Google Review'
  }
];

export const timeSlots = [
  '9:00 AM', '10:00 AM', '11:00 AM', '12:00 PM',
  '1:00 PM', '2:00 PM', '3:00 PM', '4:00 PM', '5:00 PM'
];

// Mock booking submission
export const submitBooking = async (bookingData) => {
  return new Promise((resolve) => {
    setTimeout(() => {
      resolve({ success: true, bookingId: Math.random().toString(36).substr(2, 9) });
    }, 1000);
  });
};

// Mock newsletter signup
export const submitNewsletter = async (email, firstName, lastName) => {
  return new Promise((resolve) => {
    setTimeout(() => {
      resolve({ success: true });
    }, 800);
  });
};